
const RPC = {
    CLIENT_JOIN             : 0,
    CLIENT_PING             : 1,
    CLIENT_LOGIN            : 2,
    CLIENT_UPDATE           : 3,
    // Was the admin's free-form "set game.state to any value" RPC,
    // fired only by Panel.vue's RANKING/FIN/REINICIAR/SELECCION USUARIOS
    // footer buttons - all four removed once stage playback's own lifecycle
    // (start/advance/end a stage, sector holds, etc.) made jumping the whole
    // game to an arbitrary state by hand both redundant and a good way to
    // desync it from a stage actually in progress. Renamed instead of
    // deleted so the 0..N id sequence stays dense (same reasoning as
    // RESERVED_UNUSED_20 below) - nothing sends or handles this id anymore.
    RESERVED_UNUSED_4       : 4,
    CLIENT_AUTH             : 5,
    GET_CLIENTS             : 6,
    LAUNCH_TITLE            : 7,
    LAUNCH_ACTIVITY         : 8,
    UPDATE_ACTIVITY         : 9,
    END_ACTIVITY            : 10,
    CLIENT_TOAST            : 11,
    UPDATE_VIEW             : 12,
    CLIENT_CLEAN            : 13,
    CLIENT_RELOAD           : 14,
    EDIT_ACTIVITY           : 15,
    REGISTER_ACTIVITY       : 16,
    DELETE_USER_DATA        : 17,
    REMOVE_ACTIVITY         : 18,
    UPDATE_LOGOS            : 19,
    // Was a second "GET_CLIENTS" key - a duplicate object-literal key silently
    // collapses onto the first one in JS (keeping this value, 20, but the
    // position of the id:6 entry), which desyncs get_rpc_name()'s index lookup
    // for every id from here on. Renamed instead of deleted so the 0..N id
    // sequence stays dense. Neither this nor GET_CLIENTS(6) is wired to a
    // handler on either side.
    RESERVED_UNUSED_20      : 20,
    CLIENT_KICK             : 21,
    CLIENT_RELOAD_ALL       : 22,
    CLIENT_SYNC             : 23,
    CLIENT_SYNC_HANDSHAKE   : 24,
    SYNC_HANDSHAKE_INFO     : 25,
    CLIENT_KICK_ALL         : 26,
    RESET_ACTIVITY          : 27,
    UPDATE_STYLES           : 28,
    TIMER_STOP              : 29,
    UPLOAD_IMAGES           : 30,
    REMOVE_IMAGE            : 31,
    SAVE_AVATAR             : 32,
    CANCEL_LAUNCH_ACTIVITY  : 33,
    CLIENT_DEBUG            : 34,
    CLIENT_REGISTER         : 35,
    CLIENT_DESTROY          : 36,
    UPLOAD_JSON             : 37,
    CHANGE_ROLE             : 38,
    DUPLICATE_QUESTION      : 39,
    // Appended - keep existing numeric values stable, only add new ones at the end,
    // so the wire protocol stays backwards compatible.
    ACK                     : 40,
    REQUEST_SYNC            : 41,
    REGISTER_SEASON         : 42,
    EDIT_SEASON             : 43,
    REMOVE_SEASON           : 44,
    REGISTER_STAGE          : 45,
    EDIT_STAGE              : 46,
    REMOVE_STAGE            : 47,
    REORDER_STAGES          : 48,
    START_STAGE             : 49,
    END_STAGE               : 50,
    REGISTER_RANKING        : 51,
    EDIT_RANKING            : 52,
    REMOVE_RANKING          : 53,
    REGENERATE_JOIN_CODE    : 54,
    START_STAGE_PLAYBACK    : 55,
    PAUSE_STAGE_PLAYBACK    : 56,
    RESUME_STAGE_PLAYBACK   : 57,
    NEXT_STAGE_QUESTION     : 58,
    PREVIOUS_STAGE_QUESTION : 59,
    VALIDATE_JOIN_CODE      : 60,
    JOIN_CODE_RESULT        : 61,
    CHECK_USERNAME          : 62,
    USERNAME_CHECK_RESULT   : 63,
    CLIENT_AUTH_RESULT      : 64,
    RESTART_STAGE           : 65,
    REORDER_ACTIVITIES      : 66,
    REGISTER_SECTOR         : 67,
    EDIT_SECTOR             : 68,
    REMOVE_SECTOR           : 69,
    SESSION_ALREADY_ACTIVE  : 70,
    TEST_RUN_SECTOR_ACTION  : 71,
    REGENERATE_SEASON_JOIN_CODE : 72,
    UPLOAD_SEASON_MODEL     : 73,
    REMOVE_SEASON_MODEL     : 74,
    SELECT_EVENT            : 75,
    MEDIA_READY             : 76,
    PRESENTER_STEP          : 77,
    RETURN_TO_LOBBY         : 78,
    STOP_STAGE_PLAYBACK     : 79,
    get_rpc_name(rpc_id){
        var rpclist = Object.keys(RPC);
        return rpclist[rpc_id];
    }
};

module.exports = RPC;
